import React, { useContext } from 'react';
import { formatString } from '../../../../assets/js/utils/formatString';
import { AddedToCartNotice } from '../AddedToCartNotice/AddedToCartNotice';
import { formatDate } from '../../../../assets/js/utils/formatDate';
import { PriceCalculationContext } from '../../PriceCalculationContext';
import { Loader } from '../../../../molecules/Loader/Loader';
import { getOrgNameFromOrgId } from '../../utils/getOrgNameFromOrgId';

function CalculationResult() {
    const {
        calculationResult,
        handleAddToCart,
        addToCartIsLoadingText,
        showAddedToCart,
        productData,
        organizationData,
        resourcedTexts,
    } = useContext(PriceCalculationContext);

    if (!calculationResult) return null;

    const { calculationId, calculations, variantName, totalPriceString } = calculationResult;

    if (!calculationId || calculations?.length === 0) return null;

    const { name, startDate, endDate } = calculations[0];
    const hasPeriods = productData.calculationType !== 'NoEndDate';
    const showAddToCartIsLoading = Boolean(addToCartIsLoadingText);

    function handleAddToCartClick() {
        handleAddToCart(calculations.length);
    }

    return (
        <div className="calculation-result">
            <div className="calculation-result__top">
                <h4 className="calculation-result__heading">
                    <span className="calculation-result__heading-left">
                        <span>{name}</span>

                        {variantName && (
                            <span className="calculation-result__heading-variant-title">{variantName}</span>
                        )}
                    </span>
                </h4>

                <h5>{resourcedTexts.calculationPeriodHeading}</h5>
                {hasPeriods ? (
                    <div>
                        {formatDate(startDate)} {resourcedTexts.calculationPeriodTill} {formatDate(endDate)}
                    </div>
                ) : (
                    <div>
                        {resourcedTexts.calculationPeriodFrom} {formatDate(startDate)}
                    </div>
                )}

                <table className="calculation-result__table">
                    <thead>
                        <tr>
                            <th scope="col">{resourcedTexts.calculationOrganizationHeading}</th>
                            <th scope="col">{resourcedTexts.calculationAmountHeading}</th>
                            <th scope="col">{resourcedTexts.calculationPriceHeading}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {calculations.map(({ organizationId, amount, totalPriceString }) => (
                            <tr key={organizationId}>
                                <td>{getOrgNameFromOrgId(organizationData, organizationId)}</td>
                                <td>{amount}</td>
                                <td>{totalPriceString}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="calculation-result__total">{totalPriceString}</div>

            {productData.hasConditionalProducts && (
                <div className="calculation-result__conditional-notice">
                    {formatString(resourcedTexts.conditionalProductNotice, [productData.name])}
                </div>
            )}

            <div className="calculation-result__button-wrapper">
                <button type="button" className="button primary" onClick={handleAddToCartClick}>
                    {resourcedTexts.addToCart}
                </button>
            </div>

            {showAddedToCart ? (
                <AddedToCartNotice />
            ) : (
                showAddToCartIsLoading && <Loader text={addToCartIsLoadingText} />
            )}
        </div>
    );
}

export { CalculationResult };
